var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAirPid = function SvgAirPid(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M1.21 2.96h1.25v18.08H1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "m9.54 11.57.36.78H1.94v-.78zM22.79 11.57v.78h-9.74l-.38-.78z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.888,
    d: "M2.03 12.16S5.19-3.53 8.91 5.97s5.28 15.28 7.61 15.11c2.34-.17 5.15-8.92 5.15-8.92",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAirPid);
export default ForwardRef;